<style src="css/create.css" scoped></style>
<template>
    <div style="padding-top: 1rem">
        <div class="fixedBox">
            <div class="topBox">
                <div class="backIcon" @click="showMask"></div>
                <div class="topTitle">写文章</div>
                <div class="rule" @click="configBtn()">发布</div>
            </div>
        </div>
        <div class="mainBox">
            <textarea placeholder="请输入标题（5-30个字）" class="title" v-model="title" maxlength="30" minlength="5"></textarea>
            <vue-html5-editor :content="content" :height="400" placeholder="请开始你的创作" @change="updateData"></vue-html5-editor>
<!--            <qiniu event-Name="pic" :defaultimg="pic"></qiniu>-->
            <div class="picTitle">上传封面</div>
            <div class="picBox">
                <img :src="EnvUrl+pic" alt="" v-if="pic">
                <input type="file" @change="change">
            </div>

        </div>

        <div class="maskBox" v-if="mask">
            <div class="mask">
                <div class="maskContent">是否保存草稿？</div>
                <div class="maskBtnBox">
                    <sapn @click="back">不保存</sapn><span @click="save(-1)">保存草稿</span>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources,getSourcesJson} from "../api"
    import moment from 'moment/moment'
    import {serialize} from 'utils/index'
    import Vue from "vue";
    import VueHtml5Editor from "vue-html5-editor";
    Vue.use(VueHtml5Editor, {
        // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
        // global component name
        name: 'vue-html5-editor',
        // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
        // if set true,will append module name to toolbar after icon
        showModuleName: false,
        // 自定义各个图标的class，默认使用的是font-awesome提供的图标
        // custom icon class of built-in modules,default using font-awesome
        icons: {
            text: 'fa fa-pencil',
            color: 'fa fa-paint-brush',
            font: 'fa fa-font',
            align: 'fa fa-align-justify',
            list: 'fa fa-list',
            link: 'fa fa-chain',
            unlink: 'fa fa-chain-broken',
            tabulation: 'fa fa-table',
            image: 'fa fa-file-image-o',
            hr: 'fa fa-minus',
            eraser: 'fa fa-eraser',
            undo: 'fa-undo fa',
            'full-screen': 'fa fa-arrows-alt',
            info: 'fa fa-info'
        },
        // 配置图片模块
        // config image module
        image: {
            // 文件最大体积，单位字节  max file size
            sizeLimit: 512 * 1024 * 10,
            // 上传参数,默认把图片转为base64而不上传
            // upload config,default null and convert image to base64
            upload: {
                url: 'https://up.qbox.me',
                headers: {

                },
                params: {
                    token: localStorage.getItem('token')
                },
                fieldName: 'file'
            },
            // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
            // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
            // set null to disable compression
            compress: null,
            // 响应数据处理,最终返回图片链接
            // handle response data，return image url
            uploadHandler (responseText) {
                console.log(JSON.parse(responseText));
                // default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
                var json = JSON.parse(responseText)
                return 'https:https://cdn.ysqingxin.com/'+json.key
            }
        },
        // 语言，内建的有英文（en-us）和中文（zh-cn）
        // default en-us, en-us and zh-cn are built-in
        language: 'zh-cn',
        // 自定义语言
        i18n: {
            // specify your language here
            'zh-cn': {
                'align': '对齐方式',
                'image': '图片',
                'list': '列表',
                'link': '链接',
                'unlink': '去除链接',
                'table': '表格',
                'font': '文字',
                'full screen': '全屏',
                'text': '排版',
                'eraser': '格式清除',
                'info': '关于',
                'color': '颜色',
                'please enter a url': '请输入地址',
                'create link': '创建链接',
                'bold': '加粗',
                'italic': '倾斜',
                'underline': '下划线',
                'strike through': '删除线',
                'subscript': '上标',
                'superscript': '下标',
                'heading': '标题',
                'font name': '字体',
                'font size': '文字大小',
                'left justify': '左对齐',
                'center justify': '居中',
                'right justify': '右对齐',
                'ordered list': '有序列表',
                'unordered list': '无序列表',
                'fore color': '前景色',
                'background color': '背景色',
                'row count': '行数',
                'column count': '列数',
                'save': '确定',
                'upload': '上传',
                'progress': '进度',
                'unknown': '未知',
                'please wait': '请稍等',
                'error': '错误',
                'abort': '中断',
                'reset': '重置'
            }
        },
        // 隐藏不想要显示出来的模块
        // the modules you don't want
        hiddenModules: [
            'info'
        ],
        // 自定义要显示的模块，并控制顺序
        // keep only the modules you want and customize the order.
        // can be used with hiddenModules together
        visibleModules: [
            'text',
            'color',
            'font',
            'align',
            'list',
            'link',
            'unlink',
            'tabulation',
            'image',
            'hr',
            'eraser',
            'undo',
            'full-screen',
            'info'],
        // 扩展模块，具体可以参考examples或查看源码
        //extended modules
        modules: {
            // omit,reference to source code of build-in modules
        }
    })
    export default {
        data() {
            return {
                EnvUrl: `https://cdn.ysqingxin.com/`,
                title:'',
                content:'',
                pic:'',
                file:'',
                token:'',
                doctorId:'',
                author:'',
                articleId:'',
                mask:false,
            }
        },
        components: {

        },
        computed: {},
        filters: {
            time(value){
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },

        },
        methods: {
            save(n){
                let object = {};
                object.title=this.title;
                object.content=this.content;
                object.content = object.content.replace(/&nbsp;/ig, '\xa0')
                object.pic=this.pic;
                object.author=this.author;
                object.doctorId=this.doctorId;
                object.auditStatus=n;
                if (this.articleId) {
                    object.articleId=this.articleId;
                    this.modifyArticle(JSON.stringify(object));
                } else {
                    this.addArticle(JSON.stringify(object));
                }
            },
            showMask(){
                if(this.content&&this.title){
                    this.mask=true
                }else{
                    this.back()
                }
            },
            change(e) {
                this.file = e.target.files[0]
                // if (this.size) {
                //     let filesize = e.target.files[0].size
                //     if (filesize > 20971520) {
                //         alert('图片不可以超过20M')
                //     }
                // }
                this.getToken()

            },
            configBtn() {
                let that = this;
                if (this.title === "") {
                    alert("请您填写文章标题！");
                } else if (this.content === "") {
                    alert("请您填写文章内容");
                }  else if (this.pic === "") {
                    alert("请您上传封面图！");
                }else {
                    let object = {};
                    object.title=this.title;
                    object.content=this.content;
                    object.content = object.content.replace(/&nbsp;/ig, '\xa0')
                    object.pic=this.pic;
                    object.author=this.author;
                    object.doctorId=this.doctorId;
                    object.auditStatus=0;
                    if (that.articleId) {
                        object.articleId=this.articleId;
                        this.modifyArticle(JSON.stringify(object));
                    } else {
                        this.addArticle(JSON.stringify(object));

                    }
                }
            },
            async addArticle(object) {
                let data = await getSourcesJson("/bear-scale/mip/microArticle/addArticle.json", object);
                if (data.status === 0) {
                    this.$router.push(`/article`)
                } else {
                    alert(`errMsg:${data.msg}`);
                }
            },
            async modifyArticle(object) {
                let data = await getSourcesJson("/bear-scale/mip/microArticle/modifyArticle.json", object);
                if (data.status === 0) {
                    this.$router.push(`/article`)
                } else {
                    alert(`errMsg:${data.msg}`);
                }
            },
            async getArticleDetail() {
                let data = await getSources("/bear-scale/mip/microArticle/getArticleDetail.json", {
                    articleId:this.articleId
                });
                if (data.status === 0) {
                    this.title=data.articleDetail.title;
                    this.content=data.articleDetail.content;
                    this.pic=data.articleDetail.pic;
                } else {
                    alert(`errMsg:${data.msg}`);
                }
            },
            async getToken() {
                let url = `/bear-scale/api/qiniu/obtainPictureUploadToken.json`

                let response = await fetch(url, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: ""
                }).catch((error) => {
                    console.log(error)
                })

                let data = await response.json().catch((error) => {
                    console.log(error)
                })

                if (data.code === 0) {
                    this.token = data.token
                    this.uploadImg()
                }
            },
            async getTokenVueHtml5Editor() {
                let url = `/bear-scale/api/qiniu/obtainPictureUploadToken.json`

                let response = await fetch(url, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: ""
                }).catch((error) => {
                    console.log(error)
                })

                let data = await response.json().catch((error) => {
                    console.log(error)
                })

                if (data.code === 0) {
                    this.token = data.token
                }
            },
            async uploadImg() {
                let formdata = new FormData()
                formdata.append("token", this.token)
                formdata.append("file", this.file)
                let response = await fetch("https://up.qbox.me", {
                    method: "POST",
                    mode: "cors",
                    body: formdata
                }).catch((error) => {
                    console.log(error)
                })

                let data = await response.json().catch((error) => {
                    console.log(error)
                })

                if (data.key) {
                    this.pic =  data.key
                }
            },
            updateData(content){
                this.content=content
            },
            back(){

                history.back()
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            },

            async medorderwriteoff(id) {
                let data = await getSources(
                    "/depression-mip/api/medquestion/medorderwriteoff", `orderId=${id}&orderType=1`);
                if (data.status == 0) {
                    this.mask1=true;
                } else {
                    alert(`${data.msg}`);
                }
            },

        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            if(this.$route.query.articleId){
                this.articleId=this.$route.query.articleId
            }
            this.doctorId=localStorage.getItem("doctorId")
            this.author=localStorage.getItem('userName')
            !!this.articleId&&this.getArticleDetail();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/create.vue